// extracted by mini-css-extract-plugin
export default {"list":"ReviewsPage_list__IK83Q"};